import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
  Tabs,
  Tab,
  Box,
  Card,
  CardHeader,
} from "@mui/material";
import moment from "moment";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  approveRecruitmentRequest,
  rejectRecruitmentRequest,
  saveOrUpdateDraftRequest,
  verifyRecruitmentRequest,
} from "../../../store/recruitment/actions";
import { getEntities } from "../../../store/structure/actions";
import { getUserDetails } from "../../../store/profile/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import { a11yProps } from "../../common/components/TabPanel";
import UserResumeDetail from "../../profile/UserResumeDetail";
import ViewApplicationEmploymentAttachments from "./ViewApplicationEmploymentAttachments";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import TextEditorComponent from "../../common/components/TextEditorComponent";
import { ReactMultiEmail } from "react-multi-email";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ViewRequestLogs from "./ViewRequestLogs";

import axios from "axios";
import ApplicantDetails from "./ApplicantDetails";
import PdfViewer from "../../common/components/PdfViewer";
const maxCharCount = 1500;

const ApproveRecruitmentRequestDialog = (props) => {
  const {
    loading,
    approveRequestForm,
    setApproveRequestForm,
    approveRecruitmentRequest,
    getUserDetails,
    recruitmentRequest,
    entities,
    getEntities,
    verifyRecruitmentRequest,
    saveOrUpdateDraftRequest,
  } = props;

  const [loading1, setLoading1] = useState(false);
  const [application, setApplication] = useState(null);
  const { hasPermissions } = useRequiredAuth();
  const [tabValue, setTabValue] = useState(0);
  const [reviewStatusId, setReviewStatusId] = useState(0);
  const [role, setRole] = useState("");
  const [onViewProvDocument, setOnViewProvDocument] = useState(false);
  const [onViewNPSCDocument, setOnViewNPSCDocument] = useState(false);
  const [letterFooterContent, setLetterFooterContent] = useState(null);
  const [recruitmentRequestDetail, setRecruitmentRequestDetail] = useState(
    recruitmentRequest?.details || null
  );
  const [enableToFillLetter, setEnableToFillLetter] = useState(false);
  const [recruitmentRequestAttachments, setRecruitmentRequestAttachments] =
    useState(recruitmentRequest?.attachments || []);

  useEffect(() => {
    setRecruitmentRequestDetail(recruitmentRequest?.details || null);
    setRecruitmentRequestAttachments(recruitmentRequest?.attachments || []);
  }, [recruitmentRequest]);
  useEffect(() => {
    if (!entities.length) getEntities();
  }, []);
  useEffect(() => {
    getApplications();
  }, []);
  useEffect(() => {
    getUserDetails(recruitmentRequestDetail.employeeId, () => {});
  }, []);
  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${recruitmentRequestDetail?.applicantId}-draftExitContent`,
    cc: `${recruitmentRequestDetail?.applicantId}-copiedInstitution`,
  });
  const [formData, setFormData] = useState({
    requestId: recruitmentRequestDetail.id,
    effectiveDate: recruitmentRequestDetail.effectiveDate
      ? moment(recruitmentRequestDetail.effectiveDate).format("YYYY-MM-DD")
      : null,
    docLetterNo: recruitmentRequestDetail.docLetterNo,
    cc: null,
    letterBodyContent: recruitmentRequestDetail.letterBodyContent || "",
    copiedInstitutionContent:
      recruitmentRequestDetail.copiedInstitutionContent || "",
    reason: "",
  });

  const [ccEmails, setCCEmails] = useState(
    recruitmentRequestDetail && !!recruitmentRequestDetail.cc
      ? JSON.parse(recruitmentRequestDetail?.cc || [])
      : []
  );

  const [maxWidth, setMaxWidth] = useState("md");

  const handleChange = (event, newValue) => {
    setMaxWidth(newValue === 2 ? "lg" : "md");
    setTabValue(newValue);
  };

  const [showRequestReviewForm, setShowRequestReviewForm] = useState(false);
  const [showApproveRequestForm, setShowApproveRequestForm] = useState(false);
  const [showApplication, setShowApplication] = useState(false);
  const [reason, setReason] = useState("");
  const [pkiPassword, setPkiPassword] = useState("");

  const onClose = () => {
    setApproveRequestForm(false);
    setShowRequestReviewForm(false);
    setShowApproveRequestForm(false);
    setReason("");
    setPkiPassword("");
  };
  const onVerify = () => {
    const letterBodyContent =
      window.localStorage.getItem(localStorageKey.letter) ||
      formData.letterBodyContent;

    const copiedInstitutionContent =
      window.localStorage.getItem(localStorageKey.cc) ||
      formData.copiedInstitutionContent;

    formData.copiedInstitutionContent = copiedInstitutionContent;

    formData.letterBodyContent = letterBodyContent;

    verifyRecruitmentRequest(
      formData.requestId,
      {
        cc: ccEmails || [],
        letterBodyContent: letterBodyContent,
        copiedInstitutionContent: copiedInstitutionContent,
        statusId: reviewStatusId,
        reason,
        role,
      },
      onClose
    );
  };

  const getEditorContent = (data) => {
    setFormData({
      ...formData,
      letterBodyContent: data.contents,
    });
  };
  const getEditorContent3 = (data) => {
    setFormData({
      ...formData,
      copiedInstitutionContent: data.contents,
    });
    formData.copiedInstitutionContent = data.contents;
  };
  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };

  const handleSubmitDraftRequest = () => {
    const letterBodyContent =
      window.localStorage.getItem(localStorageKey.letter) ||
      formData.letterBodyContent;

    const copiedInstitutionContent =
      window.localStorage.getItem(localStorageKey.cc) ||
      formData.copiedInstitutionContent;

    formData.copiedInstitutionContent = copiedInstitutionContent;

    formData.letterBodyContent = letterBodyContent;

    saveOrUpdateDraftRequest({
      requestId: formData?.requestId || null,
      cc: ccEmails || [],
      letterBodyContent: letterBodyContent,
      copiedInstitutionContent: copiedInstitutionContent,
    });
  };
  const getApplications = async () => {
    try {
      setLoading1(true);
      const { data } = await axios.get(
        `/api/recruitment/single-application/${recruitmentRequestDetail?.applicationId}`
      );

      setApplication(data);

      setLoading1(false);
    } catch (error) {
      setLoading1(false);
    }
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={approveRequestForm}
        fullWidth
        maxWidth={maxWidth}
      >
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <span>{recruitmentRequestDetail?.requestType || ""}</span> /{" "}
            <span className="text-primary">
              {recruitmentRequestDetail?.employeeNames || ""}
            </span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>

          <div className="row">
            <div className="col-lg-9">
              <Tabs
                className="mt-2 justify-content-end"
                value={tabValue}
                onChange={handleChange}
                aria-label="tabs"
                allowScrollButtonsMobile
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab
                  className="text-capitalize"
                  label="View Request Letter"
                  {...a11yProps(0)}
                />
                <Tab
                  className="text-capitalize"
                  label="Attachments
             "
                  {...a11yProps(1)}
                />

                <Tab
                  className="text-capitalize"
                  label="User Profile"
                  {...a11yProps(2)}
                />
                <Tab
                  className="text-capitalize"
                  label="Approver Logs"
                  {...a11yProps(3)}
                />
              </Tabs>
            </div>
          </div>
        </DialogTitle>

        <DialogContent className="mt-0 mx-0" dividers>
          <div className="mx-2 mb-1 w-full">
            <div className="row">
              <div className="col">
                <button
                  onClick={() => setShowApplication(true)}
                  className="text-right btn badge badge-pill text-underline text-primary"
                >
                  View application details
                </button>
                <ApplicantDetails
                  applicantId={recruitmentRequestDetail?.applicationId}
                  showApplication={showApplication}
                  setShowApplication={setShowApplication}
                />
              </div>
              <div className="col">
                {!recruitmentRequestDetail?.docReferenceId &&
                  [1, 2].includes(recruitmentRequestDetail.statusId) &&
                  enableToFillLetter &&
                  tabValue === 0 && (
                    <Button
                      disabled={loading}
                      onClick={handleSubmitDraftRequest}
                      color={"primary"}
                      variant="contained"
                      size="small"
                      className="float-right mx-1 my-1"
                    >
                      {loading ? "Wait.." : <> Save Changes</>}
                    </Button>
                  )}

                {!recruitmentRequestDetail?.docReferenceId &&
                  [1, 2].includes(recruitmentRequestDetail.statusId) &&
                  tabValue === 0 && (
                    <Button
                      variant="outlined"
                      color={enableToFillLetter ? "warning" : "info"}
                      size="small"
                      disabled={loading}
                      onClick={() => {
                        setEnableToFillLetter(!enableToFillLetter);
                        // getNPSCReport(
                        //   npscReportDetail.id,
                        //   setShowSubmissionReport,
                        //   () => {}
                        // );
                      }}
                      className="mx-1 my-1 text-capitalized float-right px-3"
                    >
                      {enableToFillLetter ? "Preview" : "Edit Letter"}
                    </Button>
                  )}
              </div>
            </div>
          </div>
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            {tabValue === 0 && (
              <>
                {!!recruitmentRequestDetail?.docReferenceId && (
                  <>
                    <PdfViewer
                      url={
                        process.env.REACT_APP_FILES_URL +
                        "/preview/" +
                        recruitmentRequestDetail?.docReferenceId
                      }
                    />
                  </>
                )}
                {!recruitmentRequestDetail?.docReferenceId && (
                  <div className="mx-2 w-full">
                    <CustomizedLetter
                      disableToEditLetterHeader={true}
                      enableToFillLetter={enableToFillLetter}
                      ccSelectForm={
                        <>
                          <strong>Enter CC Institution Email</strong>
                          <ReactMultiEmail
                            placeholder="Enter CC Institution Email"
                            emails={ccEmails}
                            onChange={(_emails) => {
                              setCCEmails(_emails);
                            }}
                            getLabel={(email, index, removeEmail) => {
                              return (
                                <div data-tag key={index}>
                                  {email}
                                  <span
                                    data-tag-handle
                                    onClick={() => removeEmail(index)}
                                  >
                                    ×
                                  </span>
                                </div>
                              );
                            }}
                          />
                        </>
                      }
                      ccEmails={ccEmails}
                      docLetterNo={recruitmentRequestDetail?.docLetterNo || ""}
                      signContent={
                        <>
                          <InstitutionDetails
                            headOfInstitution={{
                              isDelegated:
                                recruitmentRequestDetail?.isActingHeadOfInstitution ||
                                false,
                              isMinster:
                                recruitmentRequestDetail?.isMinster || false,
                              firstName:
                                recruitmentRequestDetail?.ministryApproverFirstName,
                              lastName:
                                recruitmentRequestDetail?.ministryApproverLastName,
                              institutionName:
                                recruitmentRequestDetail?.ministryApproverInstitutionName,
                              positionName:
                                recruitmentRequestDetail?.ministryApproverPositionName,
                              institutionName:
                                recruitmentRequestDetail?.ministryApproverInstitutionName ||
                                "",
                              canAddInstitutionName:
                                recruitmentRequestDetail?.ministryApproverCanAddInstitutionName ||
                                false,
                            }}
                            userSignature={null}
                          />
                        </>
                      }
                      subTitle={
                        "Dear " +
                        (recruitmentRequestDetail?.lastName?.toUpperCase() +
                          " " +
                          recruitmentRequestDetail?.firstName)
                      }
                      recipientContent={
                        <>
                          {recruitmentRequestDetail?.lastName?.toUpperCase() +
                            " " +
                            recruitmentRequestDetail?.firstName}{" "}
                          <br />
                          Tel: {recruitmentRequestDetail?.phoneNumber} <br />
                          Email: {recruitmentRequestDetail?.email} <br />
                        </>
                      }
                      entitySectorId={
                        recruitmentRequestDetail?.appointingAuthEntitySectorId ||
                        recruitmentRequestDetail?.approverEntitySectorId ||
                        null
                      }
                      planningEntityId={
                        recruitmentRequestDetail?.appointingAuthPlanningEntityId ||
                        recruitmentRequestDetail?.approverPlanningEntityId ||
                        null
                      }
                      letterBodyContentInput={
                        <>
                          <TextEditorComponent
                            id="editor-exit-textarea"
                            options={{
                              autoSave: false,
                              localStorageKey: localStorageKey.letter,
                              maxCharCount: maxCharCount,
                              defaultValue: !!window.localStorage.getItem(
                                localStorageKey.letter
                              )
                                ? window.localStorage.getItem(
                                    localStorageKey.letter
                                  )
                                : recruitmentRequestDetail.letterBodyContent,
                            }}
                            onEditorChange={(data) => {
                              getEditorContent(data);
                            }}
                          />
                        </>
                      }
                      letterBodyContent={
                        recruitmentRequestDetail?.letterBodyContent || ""
                      }
                      title={recruitmentRequestDetail?.letterTitle || ""}
                      copiedInstitutionContentInput={
                        <>
                          <br />
                          <strong>Enter CC Institution Name</strong>
                          <TextEditorComponent
                            id="editor-textarea6"
                            options={{
                              autoSave: false,
                              height: "200px",
                              localStorageKey: localStorageKey.cc,
                              maxCharCount: maxCharCount,
                              defaultValue: !!window.localStorage.getItem(
                                localStorageKey.cc
                              )
                                ? window.localStorage.getItem(
                                    localStorageKey.cc
                                  )
                                : recruitmentRequestDetail.copiedInstitutionContent,
                            }}
                            onEditorChange={(data) => {
                              getEditorContent3(data);
                            }}
                          />
                        </>
                      }
                      copiedInstitutionContent={
                        recruitmentRequestDetail?.copiedInstitutionContent || ""
                      }
                      loadFooterContent={(data) =>
                        handleLoadFooterContent(data)
                      }
                    />
                  </div>
                )}
              </>
            )}

            {tabValue === 1 && (
              <>
                <ViewApplicationEmploymentAttachments
                  applicationId={recruitmentRequestDetail.applicationId}
                  canEdit={false}
                />
              </>
            )}
            {tabValue === 2 && (
              <>
                <UserResumeDetail
                  canEdit={false}
                  allowedToEditEmail={false}
                  allowedToEditEmploymentDate={false}
                />
              </>
            )}

            {tabValue === 4 && (
              <>
                {!!recruitmentRequestDetail.provisionalDocReferenceId && (
                  <div className="row w-100">
                    <div className="col-12 ">
                      {onViewProvDocument && (
                        <PreviewPdfUrl
                          showDocument={onViewProvDocument}
                          setShowDocument={() => setOnViewProvDocument(false)}
                          document={{
                            name: `Submission of Recruitment Letter`,
                            url:
                              process.env.REACT_APP_FILES_URL +
                              "/preview/" +
                              recruitmentRequestDetail.provisionalDocReferenceId,
                          }}
                        />
                      )}

                      <Card
                        className={`mb-2 w-100 rounded hoverable-card`}
                        elevation={1}
                        variant="outlined"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <CardHeader
                          avatar={
                            <span
                              className={
                                !!recruitmentRequestDetail.provisionalDocReferenceId
                                  ? "font-weight-bold text-success"
                                  : "font-weight-bold text-primary"
                              }
                            >
                              <TextSnippetIcon />
                            </span>
                          }
                          title={
                            <Typography>
                              <strong
                                className={
                                  !!recruitmentRequestDetail.provisionalDocReferenceId
                                    ? "text-success"
                                    : ""
                                }
                              >
                                View Provisional Appointment Letter
                              </strong>
                            </Typography>
                          }
                          action={
                            <>
                              <div
                                className="d-flex flex-row align-items-center pull-right"
                                style={{ borderRadius: "4px" }}
                              >
                                <IconButton
                                  // disableRipple
                                  // className="ml-n2"
                                  size="small"
                                  onClick={() => {
                                    setOnViewProvDocument(true);
                                  }}
                                >
                                  <FilePresentIcon
                                    // fontSize="large"
                                    style={{
                                      color:
                                        !!recruitmentRequestDetail.provisionalDocReferenceId
                                          ? "#fe4066"
                                          : "#c57c7cb8",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </>
                          }
                        />
                      </Card>
                    </div>
                  </div>
                )}

                {!!recruitmentRequestDetail.npscDocReferenceId && (
                  <div className="row w-100">
                    <div className="col-12 ">
                      {onViewNPSCDocument && (
                        <PreviewPdfUrl
                          showDocument={onViewNPSCDocument}
                          setShowDocument={() => setOnViewNPSCDocument(false)}
                          document={{
                            name: `Response of Recruitment Report`,
                            url:
                              process.env.REACT_APP_FILES_URL +
                              "/preview/" +
                              recruitmentRequestDetail.npscDocReferenceId,
                          }}
                        />
                      )}

                      <Card
                        className={`mb-2 w-100 rounded hoverable-card`}
                        elevation={1}
                        variant="outlined"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <CardHeader
                          avatar={
                            <span
                              className={
                                !!recruitmentRequestDetail.npscDocReferenceId
                                  ? "font-weight-bold text-success"
                                  : "font-weight-bold text-primary"
                              }
                            >
                              <TextSnippetIcon />
                            </span>
                          }
                          title={
                            <Typography>
                              <strong
                                className={
                                  !!recruitmentRequestDetail.npscDocReferenceId
                                    ? "text-success"
                                    : ""
                                }
                              >
                                View Response of Recruitment Report
                              </strong>
                            </Typography>
                          }
                          action={
                            <>
                              <div
                                className="d-flex flex-row align-items-center pull-right"
                                style={{ borderRadius: "4px" }}
                              >
                                <IconButton
                                  // disableRipple
                                  // className="ml-n2"
                                  size="small"
                                  onClick={() => {
                                    setOnViewNPSCDocument(true);
                                  }}
                                >
                                  <FilePresentIcon
                                    // fontSize="large"
                                    style={{
                                      color:
                                        !!recruitmentRequestDetail.npscDocReferenceId
                                          ? "#fe4066"
                                          : "#c57c7cb8",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </>
                          }
                        />
                      </Card>
                    </div>
                  </div>
                )}
              </>
            )}
            {tabValue === 3 && (
              <>
                <ViewRequestLogs requestId={recruitmentRequestDetail?.id} />
              </>
            )}
          </Box>
        </DialogContent>

        {!!hasPermissions(["IS_REC_REVIEWER"]) &&
          recruitmentRequestDetail.statusId === 1 && (
            <>
              <DialogActions className="d-flex justify-content-center py-2">
                <Button
                  variant="contained"
                  color="primary"
                  type="button"
                  disabled={loading}
                  onClick={() => {
                    setReviewStatusId(2);
                    setRole("Reviewer");
                    setShowRequestReviewForm(true);
                  }}
                  className="btn btn-xs"
                >
                  Verify
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  disabled={loading}
                  onClick={() => {
                    setReviewStatusId(4);
                    setRole("Reviewer");
                    setShowRequestReviewForm(true);
                  }}
                  type="button"
                  className="mr-3 ml-3"
                >
                  Reject
                </Button>
              </DialogActions>
            </>
          )}

        {!!hasPermissions([
          "IS_HEAD_OF_INSTITUTION",
          "IS_HEAD_OF_INSTITUTION_ACTING",
        ]) &&
          recruitmentRequestDetail.statusId === 2 && (
            <>
              <DialogActions className="d-flex justify-content-center py-2">
                <Button
                  variant="contained"
                  color="success"
                  type="button"
                  disabled={loading}
                  onClick={() => {
                    setShowApproveRequestForm(true);
                  }}
                  className="btn btn-xs"
                >
                  Approve
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  disabled={loading}
                  onClick={() => {
                    setReviewStatusId(4);
                    setRole("Approver");
                    setShowRequestReviewForm(true);
                  }}
                  type="button"
                  className="mr-3 ml-3"
                >
                  Reject
                </Button>
              </DialogActions>
            </>
          )}
      </Dialog>
      {showApproveRequestForm && (
        <ConfirmationDialog
          disabled={!pkiPassword}
          confirmationDialog={showApproveRequestForm}
          message={
            <>
              <p>Enter your RISA Digital signature password to sign</p>

              <form>
                <TextField
                  fullWidth
                  size="small"
                  id="pki-password"
                  rows={4}
                  name="pki-password"
                  type="password"
                  label="Enter your RISA Digital signature password to sign"
                  variant="outlined"
                  placeholder="Enter your RISA Digital signature password to sign"
                  value={pkiPassword}
                  onChange={(e) => {
                    setPkiPassword(e.target.value || "");
                  }}
                />
              </form>
            </>
          }
          setConfirmationDialog={setShowApproveRequestForm}
          onYes={() => {
            approveRecruitmentRequest(
              { requestId: recruitmentRequestDetail.id, password: pkiPassword },
              onClose
            );
          }}
        />
      )}

      {showRequestReviewForm && (
        <ConfirmationDialog
          disabled={!reason}
          confirmationDialog={showRequestReviewForm}
          message={
            <>
              <p>
                Are you sure you want to{" "}
                <strong
                  className={`text-${
                    reviewStatusId === 4 ? "danger" : "success"
                  }`}
                >
                  {reviewStatusId === 4 ? "reject" : "review"}
                </strong>{" "}
                this request?
              </p>
              <TextField
                fullWidth
                size="small"
                multiline
                rows={4}
                name="Reason"
                label="Type your reason .."
                variant="outlined"
                placeholder="Type your reason  .."
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value || "");
                }}
              />
            </>
          }
          setConfirmationDialog={setShowRequestReviewForm}
          onYes={() => {
            onVerify();
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ loading, recruitmentRequest, entities }) => {
  return {
    loading,
    recruitmentRequest,
    entities,
  };
};
export default connect(mapStateToProps, {
  approveRecruitmentRequest,
  rejectRecruitmentRequest,
  getUserDetails,
  getEntities,
  verifyRecruitmentRequest,
  saveOrUpdateDraftRequest,
})(ApproveRecruitmentRequestDialog);
